import _tmpl from "./bar.html";
import { LightningElement, registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import { c as classNames } from "ax/chunk_index";
let Variant = /*#__PURE__*/function (Variant) {
  Variant["Primary"] = "primary";
  Variant["Secondary"] = "secondary";
  return Variant;
}({});
let Flow = /*#__PURE__*/function (Flow) {
  Flow["Default"] = "default";
  Flow["Column"] = "column";
  return Flow;
}({});
let Size = /*#__PURE__*/function (Size) {
  Size["Large"] = "large";
  Size["Default"] = "default";
  Size["Small"] = "small";
  Size["Xsmall"] = "xsmall";
  return Size;
}({});
class Bar extends LightningElement {
  constructor(...args) {
    super(...args);
    this.ariaLabel = null;
    this.ariaLive = null;
    this.ariaPressed = null;
    this.variant = Variant.Primary;
    this.size = Size.Default;
    this.flow = Flow.Default;
    this.text = void 0;
    this.icon = void 0;
    this.iconDescription = void 0;
    this.iconSetType = void 0;
    this.disabled = false;
    /*
     * isAnchor is used to determine if the component should render
     * using a <button /> or an <a />  element.
     */
    this.href = null;
  }
  get classes() {
    return classNames("element", {
      [`variant-${this.variant}`]: Object.values(Variant).includes(this.variant),
      [`size-${this.size}`]: this.size !== "default" && Object.values(Size).includes(this.size),
      [`flow-${this.flow}`]: this.flow !== "default" && Object.values(Flow).includes(this.flow)
    });
  }
  focus() {
    this.template.querySelector("button,a")?.focus();
  }
  get isAnchor() {
    return this.href;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Bar, {
  publicProps: {
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    ariaPressed: {
      config: 0
    },
    variant: {
      config: 0
    },
    size: {
      config: 0
    },
    flow: {
      config: 0
    },
    text: {
      config: 0
    },
    icon: {
      config: 0
    },
    iconDescription: {
      config: 0
    },
    iconSetType: {
      config: 0
    },
    disabled: {
      config: 0
    },
    href: {
      config: 0
    }
  },
  publicMethods: ["focus"]
});
const __lwc_component_class_internal = _registerComponent(Bar, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;